import ProfessionalExp from './ProfessionalExp';

export default ProfessionalExp;
